var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.26978V6.40032C14 6.96037 14 7.24039 14.109 7.45431C14.2049 7.64247 14.3578 7.79545 14.546 7.89132C14.7599 8.00032 15.0399 8.00032 15.6 8.00032H19.7305M14 17.0002H8M16 13.0002H8M20 9.98847V17.2002C20 18.8804 20 19.7205 19.673 20.3622C19.3854 20.9267 18.9265 21.3856 18.362 21.6733C17.7202 22.0002 16.8802 22.0002 15.2 22.0002H8.8C7.11984 22.0002 6.27976 22.0002 5.63803 21.6733C5.07354 21.3856 4.6146 20.9267 4.32698 20.3622C4 19.7205 4 18.8804 4 17.2002V6.80024C4 5.12009 4 4.28001 4.32698 3.63827C4.6146 3.07379 5.07354 2.61484 5.63803 2.32722C6.27976 2.00024 7.11984 2.00024 8.8 2.00024H12.0118C12.7455 2.00024 13.1124 2.00024 13.4577 2.08313C13.7638 2.15662 14.0564 2.27784 14.3249 2.44232C14.6276 2.62785 14.887 2.88728 15.4059 3.40613L18.5941 6.59436C19.113 7.11321 19.3724 7.37264 19.5579 7.67539C19.7224 7.94381 19.8436 8.23644 19.9171 8.54255C20 8.88781 20 9.2547 20 9.98847Z",
    stroke: "#2E5BFF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/Docs.051fc47e7d0a2f227134b9ffb1d9b3ef.svg";
export { ForwardRef as ReactComponent };